import React from 'react';
import { connect } from 'react-redux';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { setAnswerData } from '../../actions';
import TableRow from './TableRow';
import { StyledTable, TH, OptionsText } from './styles';

const OpcionMultipleTable = ({
  reactivo,
  asignaciones,
  agrupadores,
  reactivos,
  questionIndex,
  answerData,
  setAnswerData,
  index,
}) => {
  const matches = useMediaQuery('(max-width:768px)');

  const agrupadorActual = agrupadores.filter((agrupador) =>
    agrupador.reactivos.includes(reactivo),
  )[0];

  const handleClick = (asig, res, val, id_res) => {
    let agrupadorActual;
    agrupadores.forEach((agrupador) => {
      if (agrupador.reactivos.includes(reactivo)) {
        agrupadorActual = agrupador;
      }
    });

    let respuestaActual = [];

    const respuestas = [];

    asignaciones.forEach((asignacion) => {
      if (
        asig.clave === asignacion.clave &&
        asig.nombre === asignacion.nombre &&
        asig.docente === asignacion.docente
      ) {
        respuestaActual = answerData.respuestas.find(
          (thisRes) =>
            thisRes.clave_docente === asignacion.clave_docente &&
            thisRes.clave_materia === asignacion.clave &&
            thisRes.id_reactivo === reactivo.id,
        );

        respuestas.push({
          id_respuesta: id_res,
          id_agrupador: agrupadorActual.id,
          id_reactivo: reactivo.id,
          clave_materia: asignacion.clave,
          clave_docente: asignacion.clave_docente,
          id_asignacion: asignacion.id,
          id_student_assignment: asignacion.id_student_assignment,
          respuestas: [
            {
              respuesta: res,
              valor_respuesta: val,
              id_respuesta: id_res,
              id_asignacion: asignacion.id,
            },
          ],
          tipo: 'seleccion multiple',
        });
      }
    });

    if (
      answerData.respuestas.find(
        (respuesta) =>
          respuesta.id_asignacion === asig.id &&
          respuesta.id_agrupador === agrupadorActual.id &&
          respuesta.id_reactivo === reactivo.id,
      )
    ) {
      const respuestasFiltradas = answerData.respuestas.filter(
        (respuesta) =>
          respuesta.clave_materia !== asig.clave ||
          respuesta.clave_docente !== asig.clave_docente ||
          respuesta.id_reactivo !== reactivo.id,
      );

      const isIncluded = respuestaActual.respuestas.find(
        (res) => res.id_respuesta === id_res,
      );

      if (isIncluded) {
        const previousRes = respuestaActual.respuestas.filter(
          (res) => res.id_respuesta !== id_res,
        );

        let updatedRes = [];

        respuestas.forEach((res) => {
          updatedRes = [...updatedRes, { ...res, respuestas: previousRes }];
        });

        setAnswerData({
          ...answerData,
          respuestas: [...respuestasFiltradas, ...updatedRes],
        });
      } else {
        let allRes = [];

        respuestas.forEach((res1) => {
          res1.respuestas.forEach((res2) => {
            allRes = [...allRes, res2];
          });
        });

        const newRes = respuestas.map((thisRes) => ({
          ...thisRes,
          respuestas: [
            ...respuestaActual.respuestas,
            {
              respuesta: res,
              valor_respuesta: val,
              id_respuesta: id_res,
            },
          ],
        }));

        setAnswerData({
          ...answerData,
          respuestas: [...respuestasFiltradas, ...newRes],
        });
      }
    } else {
      setAnswerData({
        ...answerData,
        respuestas: [...answerData.respuestas, ...respuestas],
      });
    }
  };

  const options = reactivo.opcions;

  const keys = [];
  const keysDuplicadas = [];
  const asignacionesVisibles = [];

  asignaciones.forEach((asignacion) => {
    const exists = keys.find(
      (key) =>
        JSON.stringify(key) ===
        JSON.stringify({
          clave: asignacion.clave,
          nombre: asignacion.nombre,
          docente: asignacion.docente,
        }),
    );
    if (!exists) {
      keys.push({
        clave: asignacion.clave,
        nombre: asignacion.nombre,
        docente: asignacion.docente,
      });

      asignacionesVisibles.push(asignacion);
    } else {
      keysDuplicadas.push({
        clave: asignacion.clave,
        nombre: asignacion.nombre,
        docente: asignacion.docente,
      });
    }
  });

  return (
    <StyledTable>
      <thead>
        <tr>
          <TH>
            <p
              style={{
                fontSize: '13px',
                fontWeight: '400',
                textAlign: 'left',
              }}>
              Asignatura
            </p>
          </TH>
          <TH>
            <p
              style={{
                fontSize: '13px',
                fontWeight: '400',
                textAlign: 'left',
              }}>
              Docente
            </p>
          </TH>
          {options.map(({ id, nombre }, i) => (
            <TH key={id} dark={i % 2 === 0}>
              <OptionsText>{nombre}</OptionsText>
            </TH>
          ))}
        </tr>
      </thead>
      <tbody>
        {asignacionesVisibles.map((asignacion, i) => {
          const isDuplicated = keysDuplicadas.find(
            (key) =>
              JSON.stringify(key) ===
              JSON.stringify({
                clave: asignacion.clave,
                nombre: asignacion.nombre,
                docente: asignacion.docente,
              }),
          );

          return (
            <TableRow
              isDuplicated={isDuplicated}
              key={asignacion.id}
              index={i}
              id={asignacion.id}
              asignatura={asignacion.nombre}
              docente={asignacion.docente}
              options={options}
              reactivo={reactivo}
              handleClick={(res, val, id_res) =>
                handleClick(asignacion, res, val, id_res)
              }
            />
          );
        })}
      </tbody>
    </StyledTable>
  );
};

const mapStateToProps = (state) => ({
  asignaciones: state.asignaciones,
  agrupadores: state.agrupadores,
  reactivos: state.reactivos,
  questionIndex: state.questionIndex,
  answerData: state.answerData,
});

const mapDispatchToProps = {
  setAnswerData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OpcionMultipleTable);
